import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { TRACKING_ITEM } from '../enums/tracking_item.enum';
import { TrackingService } from './tracking.service';

@Injectable({
    providedIn: 'root'
})
export class HrefInterceptorService {
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private trackingService = inject(TrackingService);

    initialise(): void {
        document.onclick = (_event) => {
            const tEvent = _event || window.event;
            const element = (tEvent.target as HTMLAnchorElement) || (tEvent.srcElement as HTMLAnchorElement);
            let asset = '';
            let fragment = '';
            let href = '';
            if (element.tagName === 'A' && element.href) {
                href = element.href;
            }
            if (element.matches(':where(a) :scope')) {
                href = element.closest('a').href;
            }
            if (href) {
                if (!href.includes(environment.strengthscopeUrl)) {
                    this.trackingService.addTrackingItem(
                        TRACKING_ITEM.INLINE_LINK,
                        element.title +
                            ':[from]' +
                            this.trackingService.cleanRoute(this.router.url) +
                            ':[to]' +
                            this.trackingService.cleanRoute(href)
                    );
                }
                if (href.includes('#')) {
                    fragment = href.split('#').pop().split('?')[0];
                }
                if (href.includes('asset=')) {
                    asset = href.split('asset=').pop();
                }
                if (!href.startsWith('/') && !href.startsWith(environment.url)) {
                    _event.preventDefault();
                    window.open(href, '_blank', 'noopener noreferrer');
                }
            }
            // we are doing the next steps so that the app will not reload - instead it will update the route
            if (asset) {
                _event.preventDefault();
                const state = { ...this.activatedRoute.snapshot.queryParams, asset: asset };
                const url = this.router
                    .createUrlTree([], { relativeTo: this.activatedRoute, queryParams: state, fragment: fragment })
                    .toString();
                this.router.navigateByUrl(url);
            }
        };
    }
}
